import { TContractType } from '@brickwise/asset-validation/dist/schema/enums';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastSelectField } from 'src/components/mui-overrides/SelectTextField';

interface Props {
  disabled?: boolean;
}

export const ContractTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  return (
    <DefaultFastSelectField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.rentalinformation.fields.contracttype')}
      fieldName="rentalDetails.contractType"
      options={[
        {
          value: TContractType.open,
          label: t('general.contracttype.open'),
        },
        {
          value: TContractType.closed,
          label: t('general.contracttype.closed'),
        },
        {
          value: TContractType.notRented,
          label: t('general.contracttype.notRented'),
        },
      ]}
    />
  );
};
